import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { paymentRoutes } from './routes';
export class Payment {
  constructor() {
    _defineProperty(this, "routes", paymentRoutes);
  }
  async applyCoupon(data, options) {
    const resp = await requestService('payment').post(this.routes.coupon, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAccountBalance(data, options) {
    const resp = await requestService('payment').get(this.routes.balance(data.accountId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCoupons(data, options) {
    const resp = await requestService('payment').get(this.routes.coupon, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAutopayMethod(data, options) {
    const resp = await requestService('payment').get(this.routes.autopayMethod, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setAutopayMethod(data, options) {
    const resp = await requestService('payment').post(this.routes.autopayMethod, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getFinalStatements(data, options) {
    const resp = await requestService('payment').get(this.routes.finalStatement, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getFSEInfos(data, options) {
    const resp = await requestService('payment').post(this.routes.getFSEInfos, {
      residencyIds: [...data.residencyIds]
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getInvoices(options) {
    const resp = await requestService('payment').get(this.routes.getInvoices, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getInvoicesV2(data, options) {
    const resp = await requestService('payment').get(this.routes.getInvoicesV2, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getUpcomingInvoices(options) {
    const resp = await requestService('payment').get(this.routes.getUpcomingInvoices, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async submitFinalStatements(data, options) {
    const resp = await requestService('payment').post(this.routes.finalStatementSubmit, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateFinalStatements(data, options) {
    const resp = await requestService('payment').put(this.routes.finalStatement, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePaymentMethod(data, options) {
    const resp = await requestService('payment').delete(this.routes.paymentMethod, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPaymentMethods(data, options) {
    const resp = await requestService('payment').get(this.routes.paymentMethod, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPaymentSummary(data, options) {
    const resp = await requestService('payment').get(this.routes.paymentSummary, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPublicKey(data, options) {
    const resp = await requestService('payment').get(this.routes.publickey, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSetupIntent(data, options) {
    const resp = await requestService('payment').post(this.routes.setupIntent, {
      paymentMethodType: 'Card'
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSetupIntentWithAutopay(data, options) {
    const resp = await requestService('payment').post(this.routes.setupIntentWithAutopay, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSetupIntentWithSubscription(data, options) {
    const resp = await requestService('payment').post(this.routes.setupIntentWithSubscription, {
      paymentMethodType: 'Card'
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubscription(data, options) {
    const resp = await requestService('payment').get(this.routes.subscription, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postPayoutACHDirectDeposit(data, options) {
    const resp = await requestService('payment').post(this.routes.achDirectDeposit, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSetupIntentWithCoupon(data, options) {
    const resp = await requestService('payment').post(this.routes.setupIntentWithCoupon, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putPayoutACHDirectDeposit(data, options) {
    const resp = await requestService('payment').put(this.routes.achDirectDeposit, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPayoutACHDirectDeposit(data, options) {
    const resp = await requestService('payment').get(this.routes.achDirectDeposit + "?propertyId=".concat(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyPayoutACHDirectDepositsList(data, options) {
    const resp = await requestService('payment').get(this.routes.companyAchDirectDeposit, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postPayoutRegularCheck(data, options) {
    const resp = await requestService('payment').post(this.routes.regularCheck, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putPayoutRegularCheck(data, options) {
    const resp = await requestService('payment').put(this.routes.regularCheck, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPayoutRegularCheck(data, options) {
    const resp = await requestService('payment').get(this.routes.regularCheck + "?propertyId=".concat(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyPayoutRegularChecksList(data, options) {
    const resp = await requestService('payment').get(this.routes.companyRegularCheck, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyPayoutMethods(options) {
    const resp = await requestService('payment').get(this.routes.payoutMethods, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putPayoutMethods(data, options) {
    const resp = await requestService('payment').put(this.routes.postPayoutMethod, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCompanyPayoutMethod(data, options) {
    const resp = await requestService('payment').post(this.routes.postPayoutMethod, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async assignCompanyPayoutMethodToProperty(data, options) {
    const resp = await requestService('payment').post(this.routes.assignPayoutMethod, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidentAccountTransactionHistory(data, options) {
    const params = data;
    const resp = await requestService('payment').get(this.routes.residentTransactionHistory, _objectSpread({
      params
    }, options.cancelToken));
    return resp.data;
  }
  async getTransactionHistoryV2Listing(data, options) {
    const resp = await requestService('payment').post(this.routes.transactionHistoryV2Listing, data.transactionIds, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getStripeProduct(data, options) {
    const params = data;
    const resp = await requestService('payment').get(this.routes.product, _objectSpread({
      params
    }, options.cancelToken));
    return resp.data;
  }
  async getAutopayMethodByAccountId(data, options) {
    const resp = await requestService('payment').get(this.routes.autopayByAccountId(data.accountId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async sendBalanceRemainder(data, options) {
    const resp = await requestService('payment').post(this.routes.balanceRemainder(data.accountId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async sendBalanceRemainderToMultipleAccounts(data, options) {
    const resp = await requestService('payment').post(this.routes.balanceRemainderToMultipleAccounts, data.data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidenciesFees(data, options) {
    const resp = await requestService('payment').post(this.routes.batchGetResidencyFee, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setResidenciesFees(data, options) {
    const resp = await requestService('payment').post(this.routes.batchResidencyFee, data.data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyFees(data, options) {
    const resp = await requestService('payment').get(this.routes.propertyFee, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getAccountSetupFeePrice(data, options) {
    const resp = await requestService('payment').get(this.routes.accountSetupFeePrice, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getResidencyFees(data, options) {
    const resp = await requestService('payment').get(this.routes.residencyFee, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async updateResidencyFees(data, options) {
    const resp = await requestService('payment').post(this.routes.residencyFee, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyFees(data, options) {
    const resp = await requestService('payment').post(this.routes.propertyFee, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createSetupIntentWithPaymentMethodReplacement(data, options) {
    const resp = await requestService('payment').post(this.routes.setupIntentWithReplace, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUsersPaperUsage(options) {
    const resp = await requestService('payment').get(this.routes.paperUsage, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyPaymentMethod(data, options) {
    const resp = await requestService('payment').get(this.routes.propertyPaymentMethodById(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setPropertyPaymentMethod(data, options) {
    const resp = await requestService('payment').put(this.routes.propertyPaymentMethod, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getStripeProducts(options) {
    const resp = await requestService('payment').get(this.routes.stripeProducts, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBillingSchedule(options) {
    const resp = await requestService('payment').get(this.routes.billingSchedule, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidentPaymentSettings(data, options) {
    const resp = await requestService('payment').get(this.routes.paymentSettingsBaseUrl(data.residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putResidentPaymentSettings(data, options) {
    const resp = await requestService('payment').put(this.routes.paymentSettingsBaseUrl(data.residencyId), {
      statementCap: data.statementCap
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getStripeSubscription(data, options) {
    const resp = await requestService('payment').get(this.routes.stripesubscription, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postRefundOrCredit(data, options) {
    const resp = await requestService('payment').post(this.routes.postRefundOrCredit, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postUndoRefund(data, options) {
    const resp = await requestService('payment').post(this.routes.postUndoRefund, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getStripeInvoice(data, options) {
    const resp = await requestService('payment').get(this.routes.stripeinvoice, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}